// import { ICON_ID } from '@gerenciatd/next.components.icon';
import iconLibrary from './iconLibrary';


/* INTERNET KINDS */
export const FIBER = "FIBRA";
export const COPPER = "COBRE";

export const usageStructure = {
  data: {
    color: 'grey',
    tabText: 'Datos',
    ballText: 'Datos',
    wrapperClass: 'greenBall',
  },
  voice: {
    color: 'pink',
    tabText: 'Voz',
    ballText: 'Voz',
    wrapperClass: 'pinkBall',
  },
  sms: {
    color: 'orange',
    tabText: 'SMS',
    ballText: 'SMS',
    wrapperClass: 'orangeBall',
  },
  others: {
    color: 'purple',
    tabText: 'Otros',
    ballText: 'Otros',
    wrapperClass: 'purpleBall',
  },
};

export const appLogo = {
  classIcon: iconLibrary.logoMovistar,
  badge: false,
  title: 'Movistar',
  label: '',
  target: '_self',
  link: 'https://www.movistar.es',
  tagging: false,
  wrapperClass: '',
};

export const kindProductStructure = {
  mobile: {
    visualText: 'Móvil',
    icon: 'Movil',
  },
  phone: {
    visualText: 'Fijo',
    icon: 'Fijo',
  },
  tv: {
    visualText: 'Televisión',
    icon: 'Tv',
  },
};
export const iconTabsLabelUsageDetail = {
  data: 'Datos',
  voice: 'Fijo',
  sms: 'Sms',
  others: 'Informacion',
};

export const usageIntervals = {
  100: 'fullInterval',
  80: 'lastInterval',
  60: 'thirdInterval',
  40: 'secondInterval',
  20: 'firstInterval',
  0: 'zeroInterval',
};
/* FAKES PROPS */
export const fakeSettings = {
  speed: 2,
  primaryColor: '#F3F3F3',
  secondaryColor: '#ECEBEB',
};
export const modalsLibrary = {
  dataBonusDeleted: {
    fetching: {
      subtitle:
        'Si das de baja este bono de datos infinito, dejarás de disfrutar de datos ilimitados en tu línea.',
      description:
        'Recuerda que puedes contratar datos adicionales siempre que lo necesites.',
    },
    error: {
      title: 'Algo ha ido mal',
      description:
        'No hemos podido terminar tu petición. Por favor, inténtalo de nuevo más tarde.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
    },
    success: {
      title: 'Todo ha ido bien',
      description: 'Los datos extra se han desactivado correctamente.',
      icon: iconLibrary.okNovum,
      buttonLabel: 'Aceptar',
    },
    CONT_EA_000111: {
      title: 'No hemos podido dar de baja los datos extra',
      description:
        'Tienes otra tramitación en curso. Por favor inténtelo de nuevo más adelante.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
      tagueo: 'error-tramitacionEnCurso-bajaExtraDatos',
    },
    'TCOL-PEDIDOS-008': {
      // title: 'Para continuar <span className="bold"> llámanos gratis al 1004 </span>',
      title: 'Para continuar llámanos gratis al 1004',
      // img: ICON_ID.custommerSupport,
      imgAlt: 'Llama al 1004',
      buttonLabel: 'LLÁMANOS GRATIS',
    },
  },
  dataBonusHired: {
    fetching: {
      description:
        'Si disfrutabas de otro extra de datos, lo daremos de baja automáticamente.',
    },
    error: {
      title: 'Algo ha ido mal',
      description:
        'No hemos podido terminar tu petición. Por favor, inténtalo de nuevo más tarde.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
    },
    success: {
      title: 'Todo ha ido bien',
      description: 'Los datos extra se han activado correctamente.',
      icon: iconLibrary.okNovum,
      buttonLabel: 'Aceptar',
    },
    CONT_EA_000111: {
      title: 'No hemos podido dar de alta los datos extra',
      description:
        'Tienes otra tramitación en curso. Por favor inténtelo de nuevo más adelante.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
      tagueo: 'error-tramitacionEnCurso-altaExtraDatos',
    },
    'TCOL-PEDIDOS-008': {
      // title: 'Para continuar <span className="bold"> llámanos gratis al 1004 </span>',
      title: 'Para continuar llámanos gratis al 1004',
      // img: ICON_ID.custommerSupport,
      imgAlt: 'Llama al 1004',
      buttonLabel: 'LLÁMANOS GRATIS',
    },
  },
  sharedDataBonusDeleted: {
    fetching: {
      description:
        'Recuerda que puedes contratar datos adicionales siempre que lo necesites.',
    },
    error: {
      title: 'Algo ha ido mal',
      description:
        'No hemos podido terminar tu petición. Por favor, inténtalo de nuevo más tarde.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
    },
    success: {
      title: 'Todo ha ido bien',
      description: 'Los datos extra se han desactivado correctamente.',
      icon: iconLibrary.okNovum,
      buttonLabel: 'Aceptar',
    },
    CONT_EA_000111: {
      title: 'No hemos podido dar de baja los datos extra',
      description:
        'Tienes otra tramitación en curso. Por favor inténtelo de nuevo más adelante.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
      tagueo: 'error-tramitacionEnCurso-bajaExtraDatos',
    },
    'TCOL-PEDIDOS-008': {
      // title: 'Para continuar <span className="bold"> llámanos gratis al 1004 </span>',
      title: 'Para continuar llámanos gratis al 1004',
      img: iconLibrary.custommerSupport,
      imgAlt: 'Llama al 1004',
      buttonLabel: 'LLÁMANOS GRATIS',
    },
  },
  sharedDataBonusHired: {
    fetchingWhite: {},
    error: {
      title: 'Algo ha ido mal',
      description:
        'No hemos podido terminar tu petición. Por favor, inténtalo de nuevo más tarde.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
    },
    success: {
      title: 'Todo ha ido bien',
      description: 'Los datos extra se han activado correctamente.',
      icon: iconLibrary.okNovum,
      buttonLabel: 'Aceptar',
    },
    CONT_EA_000111: {
      title: 'No hemos podido dar de alta los datos extra',
      description:
        'Tienes otra tramitación en curso. Por favor inténtelo de nuevo más adelante.',
      icon: iconLibrary.alertNovum,
      buttonLabel: 'Aceptar',
      tagueo: 'error-tramitacionEnCurso-altaExtraDatos',
    },
    'TCOL-PEDIDOS-008': {
      // title: 'Para continuar <span className="bold"> llámanos gratis al 1004 </span>',
      title: 'Para continuar llámanos gratis al 1004',
      img: iconLibrary.custommerSupport,
      imgAlt: 'Llama al 1004',
      buttonLabel: 'LLÁMANOS GRATIS',
    },
  },
};

export const adicionalDialogue = [
  {
    fatherId: 'tv',
    motiveId: [
      {
        issueId: '725',
        label: 'En el mando',
        issuelabel: 'Televisión',
      },
      {
        issueId: '723',
        label: 'En el desco',
        issuelabel: 'Televisión',
      },
      {
        issueId: '31',
        label: 'En la TV',
        issuelabel: 'Televisión',
        childrenId: 'inTv',
      },
      {
        issueId: '728',
        label: 'Con el PIN',
        issuelabel: 'Televisión',
      },
      {
        issueId: '729',
        label: 'En otros dispositivos',
        issuelabel: 'Televisión',
      },
    ],
    kindProduct: 'tv',
  },
  {
    fatherId: 'inTv',
    motiveId: [
      {
        issueId: '723',
        label: 'No veo ningún canal',
        issuelabel: 'Televisión',
      },
      {
        issueId: '32',
        label: 'No funciona algún canal concreto',
        issuelabel: 'Televisión',
        onlyShow: 'Netflix',
        childrenId: 'inChanel',
      },
      {
        issueId: '70601',
        label: 'No funciona algún canal concreto',
        issuelabel: 'Televisión',
        onlyShow: 'No_Netflix',
      },
      // {
      //   issueId: '-1',
      //   label: 'La calidad es mala',
      //   issuelabel: 'Televisión',
      //
      // },
      // {
      //   issueId: '-1',
      //   label: 'Problemas con la grabación o con otras funcionalidades',
      //   issuelabel: 'Televisión',
      //
      // },
    ],
    kindProduct: 'tv',
  },
  {
    fatherId: 'inChanel',
    motiveId: [
      {
        issueId: '71990',
        label: 'Netflix',
        issuelabel: 'Televisión',
        serviceId: 1,
      },
      {
        issueId: '70601',
        label: 'Es otro canal distinto',
        issuelabel: 'Televisión',
      },
    ],
    kindProduct: 'tv',
  },
  {
    fatherId: 'inMobile',
    motiveId: [
      {
        issueId: '70111',
        label: 'En el buzón de voz',
        issuelabel: 'Móvil',
      },
      {
        issueId: '70101',
        label: 'En los datos móviles',
        issuelabel: 'Móvil',
      },
      {
        issueId: '11',
        label: 'En la línea',
        issuelabel: 'Móvil',
        childrenId: 'inCalls',
      },
      {
        issueId: '70110',
        label: 'En la cobertura',
        issuelabel: 'Móvil',
      },
      // {
      //   issueId: '-1',
      //   label: 'En otros servicios móviles',
      //   issuelabel: 'Móvil',
      // },
    ],
    kindProduct: 'mobile',
  },
  {
    fatherId: 'inCalls',
    motiveId: [
      {
        issueId: '70106',
        label: 'No puedo llamar',
        issuelabel: 'Móvil',
      },
      {
        issueId: '70107',
        label: 'No recibo llamadas',
        issuelabel: 'Móvil',
      },
      // {
      //   issueId: '-1',
      //   label: 'Es otra cosa',
      //   issuelabel: 'Móvil',
      // },
    ],
    kindProduct: 'mobile',
  },
  {
    fatherId: 'inPhone',
    motiveId: [
      {
        issueId: '711',
        label: 'En la línea',
        issuelabel: 'Fijo',
        onlyShow: 'cobre',
      },
      {
        issueId: '713',
        label: 'En la línea',
        issuelabel: 'Fijo',
        onlyShow: 'fibra',
      },
      {
        issueId: '722',
        label: 'En la identificación de llamadas',
        issuelabel: 'Fijo',
        serviceId: 8,
        onlyShow: 'callID',
      },
      // {
      //   issueId: '-1',
      //   label: 'Me pasa otra cosa',
      //   issuelabel: 'Fijo',
      // },
    ],
    kindProduct: 'phone',
  },
  {
    fatherId: 'inInternet',
    motiveId: [
      {
        issueId: '747',
        label: 'Problemas de navegación',
        issuelabel: 'Fijo',
        onlyShow: 'cobre',
      },
      {
        issueId: '745',
        label: 'Problemas de navegación',
        issuelabel: 'Fijo',
        onlyShow: 'fibra',
      },
      {
        issueId: '70504',
        label: 'Problemas con el repetidor wifi',
        issuelabel: 'Internet',
        kind: 'cobre',
      },
      {
        issueId: '70404',
        label: 'Problemas con el repetidor wifi',
        issuelabel: 'Internet',
        kind: 'fibra',
      },
    ],
    kindProduct: 'internet',
  },
];

export const supportModule = {
  phoneInternet: {
    motiveId: [
      {
        issueId: '747',
        label: 'Problemas de navegación',
        issuelabel: 'Fijo',
        kind: COPPER,
      },
      {
        issueId: '745',
        label: 'Problemas de navegación',
        issuelabel: 'Fijo',
        kind: FIBER,
      },
      {
        issueId: '70504',
        label: 'Problemas con el repetidor wifi',
        issuelabel: 'Internet',
        kind: COPPER,
      },
      {
        issueId: '70404',
        label: 'Problemas con el repetidor wifi',
        issuelabel: 'Internet',
        kind: FIBER,
      },
    ],
    name: 'Internet',
    icon: 'Internet',
    comments: '747',
    kindProduct: 'internet',
  },
  tv: {
    motiveId: [
      {
        issueId: '729',
        label: 'Movistar Plus en dispositivos',
        issuelabel: 'Movistar Plus en dispositivos',
      },
      {
        issueId: '725',
        label: 'En el mando',
        issuelabel: 'Televisión',
      },
      {
        issueId: '723',
        label: 'En el desco',
        issuelabel: 'Televisión',
      },
      {
        issueId: '31',
        label: 'En la TV',
        issuelabel: 'Televisión',
        childrenId: 'inTv',
      },
      {
        issueId: '728',
        label: 'Con el PIN',
        issuelabel: 'Televisión',
      },
      {
        issueId: '729',
        label: 'En otros dispositivos',
        issuelabel: 'Televisión',
      },
    ],
    name: 'TV',
    icon: 'Tv',
    comments: '725',
    kindProduct: 'tv',
  },
  mobile: {
    motiveId: [
      {
        issueId: '70111',
        label: 'En el buzón de voz',
        issuelabel: 'Móvil',
      },
      {
        issueId: '70101',
        label: 'En los datos móviles',
        issuelabel: 'Móvil',
      },
      {
        issueId: '11',
        label: 'En la línea',
        issuelabel: 'Móvil',
        childrenId: 'inCalls',
      },
      {
        issueId: '70110',
        label: 'En la cobertura',
        issuelabel: 'Móvil',
      },
    ],
    name: 'Móvil',
    icon: 'Movil',
    kindProduct: 'mobile',
  },
  phone: {
    motiveId: [
      {
        issueId: '711',
        label: 'En la línea',
        issuelabel: 'Fijo',
        kind: COPPER,
      },
      {
        issueId: '713',
        label: 'En la línea',
        issuelabel: 'Fijo',
        kind: FIBER,
      },
      {
        issueId: '722',
        label: 'En la identificación de llamadas',
        issuelabel: 'Fijo',
        serviceId: 8,
        kind: 'callID',
      },
    ],
    name: 'Fijo',
    icon: 'Fijo',
    kindProduct: 'phone',
  },
};

export const collapsibleProductsModule = [
  {
    motiveId: [
      {
        issueId: '0',
        label: '',
        issuelabel: 'Facturación',
      },
    ],
    name: 'Facturación',
    // icon: iconLibrary.breakdownSolid,
    link: 'bills',
    kindProduct: '*',
  },
  {
    motiveId: [
      {
        issueId: '0',
        label: '',
        issuelabel: 'Activación Disney+',
      },
    ],
    name: 'Activación Disney+',
    kindProduct: '*',
    modal: 'disney',
  },
  {
    motiveId: [
      {
        issueId: '0',
        label: '',
        issuelabel: 'Altas, contrataciones o pedidos',
      },
    ],
    name: 'Altas, contrataciones o pedidos',
    // icon: iconLibrary.breakdownSolid,
    kindProduct: '*',
    link: 'tracking',
  },
];
